(() => {
  'use strict';

  // Compatibility bridge. Price-per rendering is now owned by
  // assets/alden-bundle-price.js to prevent duplicate event listeners.
  const initialize = () => window.AldenBundlePrice?.init?.();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
